import ds from 'designsystem';
import styled from 'styled-components';
import { media } from 'designsystem/index';

const BlackButton = styled.a`
  display: block;
  padding-right: ${({ rightPad }) => (rightPad ? (ds.get('metrics.xs')) : '0')};
  max-height: ${ds.get('metrics.l')};
  
  &:hover {
    cursor: pointer;
  }
  
  ${media.tablet`
    max-height: 70px;
    padding-right: ${({ rightPad }) => (rightPad ? (ds.get('metrics.s')) : '0')};
  `}
  
`;

export default BlackButton;



// WEBPACK FOOTER //
// ./src/kentico-blocks/HeroImage/TextBlock/BlackButton.jsx